/** Working name — change it here (and in index.html's <title>) when the real name is picked. */
export const APP_NAME = 'Grams';
